// extracted by mini-css-extract-plugin
export default {"wrapper":"TransferPackage_wrapper__NHKsE","filters":"TransferPackage_filters__xAVid","results":"TransferPackage_results__d7sdM","pagination":"TransferPackage_pagination__BYrV-"};